import { Session } from '@benzinga/session';
import { isAbleToUseProxyRoutes } from '@benzinga/utils';
import { TrendingTopicsProxyRestful } from './proxy';
import { TrendingTopicsTransport } from './types';
import { TrendingTopicsUpstreamRestful } from './upstream';

export type { TrendingTopicsTransport } from './types';
export { TrendingTopicsProxyRestful } from './proxy';
export { TrendingTopicsUpstreamRestful } from './upstream';
export { trendingTopicsRoutes } from './routes';

export const createTrendingTopicsRestful = (session: Session): TrendingTopicsTransport => {
  if (isAbleToUseProxyRoutes()) return new TrendingTopicsProxyRestful(session);
  return new TrendingTopicsUpstreamRestful(session);
};
